import { FileTextIcon, ZapIcon, BotIcon, SmartphoneIcon, PuzzleIcon } from 'lucide-react';
export const heroChips = [{
  icon: FileTextIcon,
  label: '100% numérique — PDF'
}, {
  icon: SmartphoneIcon,
  label: 'Accès ordinateur, tablette & mobile'
}, {
  icon: ZapIcon,
  label: 'Téléchargement immédiat'
}, {
  icon: BotIcon,
  label: 'Compatible avec ChatGPT, Claude, Gemini & DeepSeek'
}, {
  icon: PuzzleIcon,
  label: 'Prompts personnalisables avec vos informations'
}];
export const stats = [{
  value: '500+',
  label: 'Professionnels satisfaits'
}, {
  value: '6+4',
  label: 'Volumes + Bonus'
}, {
  value: '99%',
  label: 'Taux de réussite'
}, {
  value: '4.9/5',
  label: '⭐ Évaluation'
}];
